/* this component accepts a list of projects and remders a select list */
import React, { Component } from 'react';
import { FormControl, InputLabel, Select } from '@mui/material';
import withStyles from '@mui/styles/withStyles';

const styleSheet = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    // margin: theme.spacing(1),
    width: '97%',
    minWidth: 120,
  },
  nselect: {
    paddingLeft: 0,
  },
});



class WalletSelect extends Component {
  constructor(props) {
    super(props);

    this.initProps = null;
  }

  setWalletSelectState = (value) => {
    if (value !== '') {
      this.props.setWalletSelectState(value);
    }
  }

  render() {

    const classes = this.props.classes;
    let walletIndex = 0; 
    let walletId = this.props.walletId;
    if (walletId != null) {
      for (let i = 0; i < this.props.wallets.length; i++) {
        if (this.props.wallets[i].walletId === walletId) {
          walletIndex = i;
          break;
        }
      }
    }

    let widthOverride = null;
    if (this.props.widthOverride != null) {
      widthOverride = this.props.widthOverride;
    }

              
    var pIdx=0;
    return (
      <FormControl   variant="standard" 
        className={classes.formControl}
        style={
          widthOverride == null
          ? {
              'width': '97%'
            }
          : {
              'width': widthOverride
            }
        }
      >
        <InputLabel shrink htmlFor="wallet">Expense wallet</InputLabel>
        <Select
          native
          value={walletIndex}
          inputProps={{
            name: 'wallet',
            id: 'wallet',
          }}
          onChange={(e) => this.setWalletSelectState(e.target.value)}
          className={classes.nselect}
        >
          {/* <option key={""} value="">Select a project...</option>*/}
          {this.props.wallets.map(n => {

            let theIdx = pIdx;
            pIdx ++;
            let displayText = 'Default';
            if (n.accountTByAccountId && n.accountTByAccountId.accountName) {
              displayText = displayText + ' - ' + n.accountTByAccountId.accountName;
            }
            return(<option key={theIdx} value={theIdx}>{displayText}</option>);
          })}
        </Select>
      </FormControl>
    );

  }
    
}

export default withStyles(styleSheet)(WalletSelect);
